import { api } from "./configs/axiosConfigs"

export const DocumentOfSalesAPI = {
    getDocumentOfSales: async (data: any) => {
        const response = await api.get(
            '/documentofsales', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    getDocumentOfSalesByCompany: async (data: any) => {
        const response = await api.get(
            '/documentofsales/listByCompany', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    updateForCompany: async (data: object) => {
        const response = await api.post(
            '/documentofsales/updateForCompany', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },
}